/**
 * Derives the canonical routing key for a request or configured entry path.
 *
 * This is the single source of truth for what a path "means". Both the redirect
 * hot path and the admin API import it; it is never reimplemented. Percent-
 * encoding is intentionally left undecoded so that `/a%2Fb` and `/a/b` remain
 * distinct routes.
 */
export function normalizePath(input: string): string {
  let value = input.trim();

  const cut = value.search(/[?#]/);
  if (cut !== -1) value = value.slice(0, cut);

  value = value.toLowerCase().replace(/\/{2,}/g, '/');

  if (!value.startsWith('/')) value = `/${value}`;

  while (value.length > 1 && value.endsWith('/')) {
    value = value.slice(0, -1);
  }

  return value;
}
